var exports = {
  "n": "xe533113f--2e292b--proof",
  "K": "xe533113f--2e292b--icon",
};

module.exports = exports;
